import { useT } from "@/i18n"
import { Badge } from "@/ui/components/ui/badge"

type Props = {
  readonly balance: number
}

export default function CreditBalanceBadge({ balance }: Props) {
  const { t } = useT("money")

  return (
    <Badge variant="secondary">
      {t("balance.credits", { count: balance })}
    </Badge>
  )
}
